/**
 * @param {String} dialogId - the ID attribute of the dialog you want to display. Can be a data-dialog as well.
 * @param {Function} callback - if you want to trigger a specific action after the dialog is opened
 * @return {Promise | null}
 */
export async function showDialog<T>(dialogId: string, callback?: () => T): Promise<void | null> {
    const dialog: HTMLJoyDialogElement | null =
        document.body.querySelector(`#${dialogId}`) || document.body.querySelector(`[data-dialog="${dialogId}"]`);

    if (!dialog || dialog.tagName !== 'JOY-DIALOG') {
        console.error(`Unable to find any joy-dialog with ID nor data-id "${dialogId}"`);
        return null;
    }

    await (dialog as HTMLJoyDialogElement)!.openDialog(callback);
}

/**
 * @return {void}
 */
export function hideAllDialogs(): void {
    Array.from(document.querySelectorAll('joy-dialog')).map((dialog) => (dialog.open = false));
}
